module.exports = {
    zh: {
        noticeMessage: '通知消息',
        systemMessage: '系统消息',
        allRead: '全部已读',
        lookAll: '查看全部',
        messageCenter: '消息中心',
        messageType: '消息类型',
        content: '内容',
        time: '时间'
    },
    en: {
        noticeMessage : 'Notification message',
        systemMessage: 'System message',
        allRead: 'All have been read',
        lookAll: 'Look at all',
        messageCenter: 'The message center',
        messageType: 'Message type',
        content: 'content',
        time: 'time'
    }
  
  }
  


// WEBPACK FOOTER //
// ./src/components/i18n/lang/messageCenter.js